import fantasktic from "./fantasktic.svg";
import backBtn from "./back-button.svg";
import logout from "./logout.png";
import noImage from "./noImage.svg";
export const ImageAsset = {
    logo:fantasktic,
    backBtn,
    logout,
    noImage,
}